import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations - common
import * as esCommon from './locales/es/common.json';
import * as enCommon from './locales/en/common.json';
import * as ptCommon from './locales/pt/common.json';

// Import translations - auth
import * as esAuth from './locales/es/auth.json';
import * as enAuth from './locales/en/auth.json';
import * as ptAuth from './locales/pt/auth.json';

// Import translations - nav
import * as esNav from './locales/es/nav.json';
import * as enNav from './locales/en/nav.json';
import * as ptNav from './locales/pt/nav.json';

// Import translations - home
import * as esHome from './locales/es/home.json';
import * as enHome from './locales/en/home.json';
import * as ptHome from './locales/pt/home.json';

// Import translations - classifieds
import * as esClassifieds from './locales/es/classifieds.json';
import * as enClassifieds from './locales/en/classifieds.json';
import * as ptClassifieds from './locales/pt/classifieds.json';

// Import translations - stores
import * as esStores from './locales/es/stores.json';
import * as enStores from './locales/en/stores.json';
import * as ptStores from './locales/pt/stores.json';

// Import translations - myads
import * as esMyads from './locales/es/myads.json';
import * as enMyads from './locales/en/myads.json';
import * as ptMyads from './locales/pt/myads.json';

// Import translations - profile
import * as esProfile from './locales/es/profile.json';
import * as enProfile from './locales/en/profile.json';
import * as ptProfile from './locales/pt/profile.json';

// Import translations - cart
import * as esCart from './locales/es/cart.json';
import * as enCart from './locales/en/cart.json';
import * as ptCart from './locales/pt/cart.json';

// Import translations - tienda
import * as esTienda from './locales/es/tienda.json';
import * as enTienda from './locales/en/tienda.json';
import * as ptTienda from './locales/pt/tienda.json';

// Import translations - help
import * as esHelp from './locales/es/ayuda.json';
import * as enHelp from './locales/en/ayuda.json';
import * as ptHelp from './locales/pt/ayuda.json';

// Import translations - dashboard
import * as esDashboard from './locales/es/dashboard.json';
import * as enDashboard from './locales/en/dashboard.json';
import * as ptDashboard from './locales/pt/dashboard.json';

// Import translations - admin
import * as esAdmin from './locales/es/admin.json';
import * as enAdmin from './locales/en/admin.json';
import * as ptAdmin from './locales/pt/admin.json';

// Import translations - forms
import * as esForms from './locales/es/forms.json';
import * as enForms from './locales/en/forms.json';
import * as ptForms from './locales/pt/forms.json';

// Import translations - legal
import * as esLegal from './locales/es/legal.json';
import * as enLegal from './locales/en/legal.json';
import * as ptLegal from './locales/pt/legal.json';

// Import translations - messages
import * as esMessages from './locales/es/messages.json';
import * as enMessages from './locales/en/messages.json';
import * as ptMessages from './locales/pt/messages.json';

// Import translations - affiliates page
import * as esAffiliates from './locales/es/affiliates.json';
import * as enAffiliates from './locales/en/affiliates.json';
import * as ptAffiliates from './locales/pt/affiliates.json';

// Define resources
const resources = {
    es: {
        common: esCommon,
        auth: esAuth,
        nav: esNav,
        home: esHome,
        classifieds: esClassifieds,
        stores: esStores,
        myads: esMyads,
        profile: esProfile,
        cart: esCart,
        tienda: esTienda,
        help: esHelp,
        dashboard: esDashboard,
        admin: esAdmin,
        forms: esForms,
        legal: esLegal,
        messages: esMessages,
        affiliates: esAffiliates
    },
    en: {
        common: enCommon,
        auth: enAuth,
        nav: enNav,
        home: enHome,
        classifieds: enClassifieds,
        stores: enStores,
        myads: enMyads,
        profile: enProfile,
        cart: enCart,
        tienda: enTienda,
        help: enHelp,
        dashboard: enDashboard,
        admin: enAdmin,
        forms: enForms,
        legal: enLegal,
        messages: enMessages,
        affiliates: enAffiliates
    },
    pt: {
        common: ptCommon,
        auth: ptAuth,
        nav: ptNav,
        home: ptHome,
        classifieds: ptClassifieds,
        stores: ptStores,
        myads: ptMyads,
        profile: ptProfile,
        cart: ptCart,
        tienda: ptTienda,
        help: ptHelp,
        dashboard: ptDashboard,
        admin: ptAdmin,
        forms: ptForms,
        legal: ptLegal,
        messages: ptMessages,
        affiliates: ptAffiliates
    }
};


// Initialize i18n
i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        defaultNS: 'common',
        fallbackLng: 'es',
        supportedLngs: ['es', 'en', 'pt'],

        // Language detection options
        detection: {
            order: ['localStorage', 'navigator', 'htmlTag'],
            caches: ['localStorage'],
            lookupLocalStorage: 'i18nextLng'
        },

        interpolation: {
            escapeValue: false // React already safes from XSS
        },

        // Disable suspense to prevent "component suspended while responding to synchronous input" errors
        react: {
            useSuspense: false
        },

        // Debug in development
        debug: import.meta.env.DEV
    });

export default i18n;

// Export language utilities
export const languages = [
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'en', name: 'English', flag: '🇺🇸' },
    { code: 'pt', name: 'Português', flag: '🇧🇷' }
];

export const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
};

export const getCurrentLanguage = () => {
    return i18n.language?.split('-')[0] || 'es';
};
